import {connect} from 'react-redux';
import React, {Component, Fragment} from 'react';
import {actions as engine} from "../reducers/engine";
import _ from 'lodash';
import Modal from "../components/general/Modal";

@connect(
	state => {
		return {
			queuedJobs: state.engine.queuedJobs,
			executingJobs: state.engine.executingJobs,
			successfulJobs: state.engine.successfulJobs,
			failedJobs: state.engine.failedJobs
		}
	},
	dispatch => {
		return {
			fetchJobs: () => dispatch(engine.fetch()),
			retryJobs: (jobId) => dispatch(engine.retry(jobId)),
            removeJob: (jobId) => dispatch(engine.remove(jobId)),
            removeAllJobs: () => dispatch(engine.removeAll()),
		};
	}
)
export default class Engine extends Component {

	retryJobs(jobId) {
		this.props.retryJobs(jobId);
	}

	componentWillUnmount() {
		clearTimeout(this.timeout);
	}

	render() {
		return (
			<Fragment>
                {/* Remove all jobs */}
                <div style={{display: 'flex'}}>
                    <button data-target={'#removeAllModal'} data-toggle="modal" style={{marginLeft: 'auto'}} className="btn btn-danger btn-sm">Remove all jobs</button>
                </div>
                <div>
                    {this.renderRemoveAllModal()}
                </div>
                <div className="row">
                    {this.renderJobCard(this.props.queuedJobs, 'Queued Jobs', 'alert-primary')}
                    {this.renderJobCard(this.props.executingJobs, 'Jobs in execution', 'alert-info')}
                    {this.renderJobCard(this.props.successfulJobs, 'Successful jobs', 'alert-success')}
                    {this.renderJobCard(this.props.failedJobs, 'Failed jobs', 'alert-danger')}
                </div>
            </Fragment>
		);
	}

	renderJobCard(jobs, header, className) {
		return (
			<div style={{maxWidth: "25%"}} className="col-md">
				<div className="card">
					<div className="card-header">
						<h5>{header}</h5>
					</div>
					<div className="card-body">
						{_.map(jobs, (job, key) => (
							<div key={key}>
								<div className={'alert fade show ' + className} data-target={'#modal-' + className + key} data-toggle="modal">
									<div><small>{job.projectName}</small></div>
                                    <span>{job.taskObjectClass.split('\\').splice(-1)} {job.languageIdentifier?(' (' + job.languageIdentifier + ')'):null}</span>
								</div>

								<div className="modal fade" id={'modal-' + className + key} tabIndex="-1" role="dialog" aria-labelledby="ModalLabel">
									<div className="modal-dialog engine-modal">
										<div className="modal-content">
											<div className="modal-header justify-content-center">
												{header === "Failed jobs" ? (
													<div>
                                                        <button data-dismiss="modal" className={"btn"} onClick={() => this.retryJobs(job.uid)}>
                                                            <i className="fa fa-refresh"></i>
                                                        </button>
                                                        <button title='Delete job including Dependencies' data-dismiss="modal" className={"btn"} onClick={() => this.props.removeJob(job.uid)}>
                                                            <i className="fa fa-close"></i>
                                                        </button>
                                                    </div>
												) : null}
												<button type="button" className="close" data-dismiss="modal"
														aria-label="Close">
													<i className="nc-icon nc-simple-remove"/>
												</button>
											</div>
											<div className="modal-body" data-jobinfo="1">
												<table>
													<tbody>
														<tr>
															<th>taskObjectClass</th>
															<td>{job.taskObjectClass}</td>
														</tr>
														<tr>
															<th>queuedCount</th>
															<td>{job.queuedCount}</td>
														</tr>
														<tr>
															<th>status</th>
															<td>{job.status}</td>
														</tr>
														<tr>
															<th>payload</th>
															<td><code>{JSON.stringify(job.payload)}</code></td>
														</tr>
														<tr>
															<th>errorMessage</th>
															<td>{job.errorMessage}</td>
														</tr>
														<tr>
															<th>executionDateTime</th>
															<td>{job.executionDateTime}</td>
														</tr>
														<tr>
															<th>creationDateTime</th>
															<td>{job.creationDateTime}</td>
														</tr>
														<tr>
															<th>finishedDateTime</th>
															<td>{job.finishedDateTime}</td>
														</tr>
														<tr>
															<th>firstQueueDateTime</th>
															<td>{job.firstQueueDateTime}</td>
														</tr>
														<tr>
															<th>lastModificationDateTime</th>
															<td>{job.lastModificationDateTime}</td>
														</tr>
														<tr>
															<th>lastQueueDateTime</th>
															<td>{job.lastQueueDateTime}</td>
														</tr>
														<tr>
															<th>relatedObjectClass</th>
															<td>{job.relatedObjectClass}</td>
														</tr>
														<tr>
															<th>relatedObjectIdentifier</th>
															<td>{job.relatedObjectIdentifier}</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		);
	}

    renderRemoveAllModal = () => {
        return (
            <Modal
                identifier="removeAllModal"
                callBack={() => {
                    this.props.removeAllJobs();
                }}
                title={"Are you sure you want to remove all jobs?"}
                dismissText="Never mind"
                actionText="Remove all"
            />
        )
    }
}



// WEBPACK FOOTER //
// ./React/src/screens/Engine.js